module.exports = __webpack_public_path__ + "img/icon-no-img.e09f3897.png";